import './DataGrid.css';
import * as React from 'react';
import ReactDataGrid, { DataGridProps } from 'react-data-grid';

const DataGrid = <T,>(props: DataGridProps<T, unknown, string>) => <ReactDataGrid
    {...props}
    className={`rdg-light ${props.className ?? ''}`}
/>
export default DataGrid;